import { createIcon } from "@chakra-ui/icons"

export const CoinbaseWallet = createIcon({
  displayName: "CoinbaseWallet",
  viewBox: "0 0 480 476",
  path: (
    <svg
      width="480"
      height="476"
      viewBox="0 0 480 476"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="239.5" cy="237.5" r="150.5" fill="white" />
      <path
        d="M195.14 202.486C195.14 197.324 199.324 193.14 204.486 193.14H275.514C280.676 193.14 284.86 197.324 284.86 202.486V273.514C284.86 278.676 280.676 282.86 275.514 282.86H204.486C199.324 282.86 195.14 278.676 195.14 273.514V202.486Z"
        fill="#0C5AFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.72 38C80.1687 38 40 78.1687 40 127.72V348.28C40 397.831 80.1687 438 129.72 438H350.28C399.831 438 440 397.831 440 348.28V127.72C440 78.1687 399.831 38 350.28 38H129.72ZM240 379.121C317.939 379.121 381.121 315.939 381.121 238C381.121 160.061 317.939 96.8785 240 96.8785C162.061 96.8785 98.8785 160.061 98.8785 238C98.8785 315.939 162.061 379.121 240 379.121Z"
        fill="#0C5AFF"
      />
    </svg>
  ),
})
